export const getCustomerVerificationService = state => state.customerVerificationService;
